import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import Search from "@mui/icons-material/Search";
import ZoomIn from "@mui/icons-material/ZoomIn";
import ZoomOut from "@mui/icons-material/ZoomOut";
import { Box, IconButton, Paper, Typography, useTheme } from "@mui/material";
import { DocumentPreview } from "components/DocumentPreview";
import { SubmissionDocument } from "./DocumentUploadSection";

interface DocumentPreviewSectionProps {
  selectedDocument?: SubmissionDocument | null;
  previewUrl?: string | null;
}

export function DocumentPreviewSection({
  selectedDocument,
  previewUrl,
}: DocumentPreviewSectionProps) {
  const theme = useTheme();

  // Always show the preview section with consistent height
  return (
    <Box
      sx={{
        height: "calc(100vh - 230px)",
        maxHeight: "600px",
        paddingTop: theme.spacing(1),
      }}
    >
      {selectedDocument && previewUrl ? (
        <DocumentPreview fileUrl={previewUrl} />
      ) : (
        <div
          className="rpv-core__viewer"
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            border: `1px solid ${theme.palette.divider}`,
          }}
        >
          <div
            style={{
              alignItems: "center",
              backgroundColor: theme.palette.grey50.main,
              borderBottom: `1px solid ${theme.palette.divider}`,
              display: "flex",
              padding: "4px",
              minHeight: "43px",
            }}
          >
            <div style={{ padding: "0px 2px" }}>
              <IconButton size="small" disabled sx={{ opacity: 0.5 }}>
                <Search fontSize="small" />
              </IconButton>
            </div>
            <div style={{ padding: "0px 2px" }}>
              <IconButton size="small" disabled sx={{ opacity: 0.5 }}>
                <ZoomOut fontSize="small" />
              </IconButton>
            </div>
            <div style={{ padding: "0px 2px" }}>
              <select
                disabled
                style={{
                  opacity: 0.5,
                  border: `1px solid ${theme.palette.grey[300]}`,
                  padding: "2px 4px",
                  fontSize: "12px",
                }}
              >
                <option>100%</option>
              </select>
            </div>
            <div style={{ padding: "0px 2px" }}>
              <IconButton size="small" disabled sx={{ opacity: 0.5 }}>
                <ZoomIn fontSize="small" />
              </IconButton>
            </div>
            <div style={{ padding: "0px 2px", marginLeft: "auto" }}>
              <IconButton size="small" disabled sx={{ opacity: 0.5 }}>
                <ChevronLeft fontSize="small" />
              </IconButton>
            </div>
            <div className="rpv-toolbar__item">
              <input
                disabled
                value="1"
                style={{
                  opacity: 0.5,
                  width: "30px",
                  border: `1px solid ${theme.palette.grey[300]}`,
                  padding: "2px",
                  fontSize: "12px",
                  textAlign: "center",
                }}
              />
            </div>
            <span className="rpv-toolbar__label" style={{ opacity: 0.5 }}>
              / 1
            </span>
            <div style={{ padding: "0px 2px" }}>
              <IconButton size="small" disabled sx={{ opacity: 0.5 }}>
                <ChevronRight fontSize="small" />
              </IconButton>
            </div>
          </div>
          <Paper
            sx={{
              p: 3,
              height: "calc(100% - 43px)",
              border: "none",
              boxShadow: "none",
              backgroundColor: theme.palette.background.paper,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 0,
            }}
          >
            <Typography
              align="center"
              sx={{
                color: theme.palette.text.secondary,
                fontSize: "14px",
                lineHeight: 1.5,
              }}
            >
              Once a submission document has been
              <br />
              uploaded, it can be previewed here
            </Typography>
          </Paper>
        </div>
      )}
    </Box>
  );
}
